import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'progress-bar',
    templateUrl: './progress-bar.html',
    styleUrls: ['./progress-bar.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressBarComponent {
    @Input({ required: true }) currentValue: number;
    @Input({ required: true }) maxValue: number;

    constructor() {
        this.currentValue = 0;
        this.maxValue = 100;
    }

    protected get progressPercentage(): number {
        return (this.currentValue / this.maxValue) * 100;
    }
}
